module.exports = __webpack_public_path__ + "static/breastplate-2aa7dbbccd1106efe951c3edb6cf6d7e.jpg";